import { inject, Service, signal, WritableSignal } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { AppLanguage, LANGUAGE_DIRECTION } from '../models/language.model';
import { LocalStorageService } from './local-storage.service';

@Service()
export class LanguageService {
  private readonly translate: TranslateService = inject(TranslateService);
  private readonly localStorage: LocalStorageService = inject(LocalStorageService);
  private readonly LANG_KEY: string = 'app_lang';
  private readonly DEFAULT_LANG: AppLanguage = AppLanguage.English;

  readonly currentLang: WritableSignal<AppLanguage> = signal<AppLanguage>(this.getStoredLang());

  initialize(): void {
    this.applyLang(this.currentLang());
  }

  toggle(): void {
    const next: AppLanguage = this.currentLang() === AppLanguage.Arabic ? AppLanguage.English : AppLanguage.Arabic;
    this.setLang(next);
  }

  setLang(lang: AppLanguage): void {
    this.localStorage.setItem(this.LANG_KEY, lang);
    this.currentLang.set(lang);
    this.applyLang(lang);
  }

  private applyLang(lang: AppLanguage): void {
    this.translate.use(lang);
    document.documentElement.lang = lang;
    document.documentElement.dir = LANGUAGE_DIRECTION[lang];
  }

  private getStoredLang(): AppLanguage {
    const stored: AppLanguage | null = this.localStorage.getItem<AppLanguage>(this.LANG_KEY);
    return stored === AppLanguage.Arabic || stored === AppLanguage.English ? stored : this.DEFAULT_LANG;
  }
}
